import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Error } from '../../../Data/error.dto';
import { AccountDetailsType, BookingType, BookedPackagesStats, Package, PackageRequest, Transaction } from '../../../Data/package.dto';
import { PackageReducer } from '../../Reducers/Dashboard/PackageReducer';
export interface PackageState {
    loading: boolean;
    packages: Package[];
    packageRequest: PackageRequest[]
    isAccountUpdated: boolean;
    account?: AccountDetailsType;
    cashfreeVendorStatus?: any;
    PackageBookings: {
        data: BookingType[];
        loading: boolean;
        isUpdated: boolean;
        booked_packages: BookedPackagesStats | null;
    };
    error: Error;
    isError: boolean;
    success: boolean;
    isPackageUpdate: boolean;
    currentPackage?: Package;
    transactions: Transaction[];
}

const initialState: PackageState = {
    packages: [],
    packageRequest: [],
    isPackageUpdate: true,
    loading: false,
    PackageBookings: {
        data: [],
        loading: false,
        isUpdated: true,
        booked_packages: null,
    },
    error: {},
    isError: false,
    success: false,
    isAccountUpdated: true,
    cashfreeVendorStatus: null,
    transactions: [],

}



const packageSlice = createSlice({
    name: 'event',
    initialState,
    reducers: {
        clearError(state) {
            state.error = {};
            state.isError = false;
        },
        setCurrentPackage(state, action: PayloadAction<Package>) {
            state.currentPackage = action.payload;
        },
        clearCurrentPackage(state) {
            delete state.currentPackage;
        }

    },
    extraReducers: (builder) => {
        // EventReducer(builder);
        PackageReducer(builder);
    },
});

export const { clearError, setCurrentPackage, clearCurrentPackage } = packageSlice.actions;


export default packageSlice.reducer;
